const getConstants = require('../../../utils/getConstants');
const { normalizeLongIdentity, selectPreferredSubmission } = require('./submissionSelection');

const { taskStates } = getConstants();
const VIEWABLE_OWN_STATES =
   taskStates.BUSY | taskStates.SUBMITTED | taskStates.PENDING_SIGNOFF | taskStates.REJECTED | taskStates.SIGNED_OFF | taskStates.COMPLETE;

module.exports = function findSubmissionForViewing({ submissions, noUser }) {
   // View answers which Submission is appropriate to display, not which Submission the user may edit/resume.
   if (!submissions) return null;

   const entries = Object.entries(submissions)
      .filter(([key]) => key !== 'main')
      .map(([, submission]) => submission)
      .filter(Boolean);

   const main = submissions.main;
   if (main && main.noSubmission != null) {
      const mainNo = normalizeLongIdentity(main.noSubmission);
      if (mainNo != null) {
         const mainSubmission = entries.find((submission) => normalizeLongIdentity(submission.noSubmission) === mainNo);
         if (mainSubmission) return mainSubmission;
      }
   }

   const normalizedUser = normalizeLongIdentity(noUser);
   if (normalizedUser != null) {
      const ownCandidates = entries
         .filter((submission) => normalizeLongIdentity(submission.noUserStartedBy) === normalizedUser)
         .filter((submission) => ((submission.state || 0) & VIEWABLE_OWN_STATES) !== 0);
      const ownPreferred = selectPreferredSubmission(ownCandidates);
      if (ownPreferred) return ownPreferred;
   }

   const otherInProgress = entries.filter((submission) => {
      const submissionUser = normalizeLongIdentity(submission.noUserStartedBy);
      return (
         submission.noSubmission != null &&
         submissionUser != null &&
         submissionUser !== normalizedUser &&
         ((submission.state || 0) & taskStates.BUSY) === taskStates.BUSY
      );
   });

   return selectPreferredSubmission(otherInProgress);
};
